/**
* DevExpress Analytics (core\internal\_objectStructureControllers.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var ObjectStructureTreeListController = (function () {
    function ObjectStructureTreeListController(propertyNames, listPropertyNames) {
        var _this = this;
        this.selectedItem = null;
        this.itemsFilter = function (item, path) {
            var realPropertyName = item.name.split('.')[0];
            return propertyNames ? propertyNames.indexOf(realPropertyName) !== -1 || $.isNumeric(realPropertyName) : true;
        };
        this.hasItems = function (item) {
            var realPropertyName = item.name.split('.')[0];
            return item.isList || (listPropertyNames ? listPropertyNames.indexOf(realPropertyName) !== -1 : false);
        };
        this.getActions = function (item) {
            return item.data && item.data['innerActions'] || [];
        };
        this.select = function (value) {
            _this.selectedItem && _this.selectedItem.isSelected(false);
            _this.selectedItem = value;
            value.isSelected(true);
        };
        this.showIconsForChildItems = function () { return true; };
    }
    ObjectStructureTreeListController.prototype.dispose = function () {
        this.selectedItem = null;
    };
    ObjectStructureTreeListController.prototype.canSelect = function (value) {
        return true;
    };
    return ObjectStructureTreeListController;
}());
exports.ObjectStructureTreeListController = ObjectStructureTreeListController;
